import { labels } from 'presentation/constant/labels'
import { validateNames } from 'presentation/utils/format'

export const validateInputString = (
  newValue: string,
  setStateError: any,
  setState: any,
  oldValue: string,
) => {
  if (newValue === '') {
    setStateError(labels.form.requiredFieldText)
  } else if (!validateNames(newValue)) {
    setState(oldValue)
  } else {
    setStateError('')
  }
}
